import { FC } from "react";

import { useBookingsPolling } from "./use-bookings-polling";

export const BookingsPollingService: FC = () => {
  useBookingsPolling();
  return null;
};
